import { useSelector } from 'react-redux'
import { ff, flags } from 'functions/roleBasedAccessUtils'
import { XMarkIcon, PencilSquareIcon } from "@heroicons/react/20/solid"
import moment from "moment";

import OrganizationBillingReceiptSectionDropdown from "components/Billing/OrganizationBillingReceiptSectionDropdown";

export default function OrganizationTrialingAthletes({
    freeTrialingAthletes = [],
    ShowEditAthleteMembershipModal = () => { },
    ShowOffboardAthleteModal = () => { }
}) {
    const userType = useSelector((state) => state.user.type)
    const adminToolsVisible = useSelector((state) => state.user.adminToolsVisible)
    const billingLocalTimestamp = useSelector((state) => state.organization.billingLocalTimestamp)
    const canAccessSidebarSalesTools = ff(flags.canAccessSidebarSalesTools, { userType: userType, adminToolsVisible: adminToolsVisible })

    const OnAthletePressed = (userId) => {
        const url = `/athlete/${userId}`
        window.open(url, '_blank')
    }

    // console.log(freeTrialingAthletes);

    if (freeTrialingAthletes.length === 0) return null;

    return (
        <OrganizationBillingReceiptSectionDropdown
            title="Trialing Athletes"
            subTitle={`${freeTrialingAthletes.length} athlete${freeTrialingAthletes.length > 1 ? 's' : ''}`}
        >
            {freeTrialingAthletes.map((athlete, index) => (
                <div
                    key={index}
                    className="flex items-center"
                >
                    <div
                        className='flex-grow flex items-center pl-4 py-4 bg-gray-50 cursor-pointer'
                        onClick={() => OnAthletePressed(athlete.id)}
                    >
                        {canAccessSidebarSalesTools &&
                            <div
                                className="-ml-4 -my-4 h-12 w-10 flex items-center justify-center"
                                onClick={(e) => { e.stopPropagation(); ShowEditAthleteMembershipModal(athlete) }}
                            >
                                <PencilSquareIcon className="ml-1 h-5 w-5 text-gray-400" />
                            </div>
                        }

                        <div className="text-sm pr-1">{athlete.firstName} {athlete.lastName}</div>

                        <div className="text-sm text-gray-500">
                            {athlete.email && <>({athlete.email})</>}
                            {!athlete.email && <>(No Email)</>}
                        </div>

                        <div className="flex-1" />

                        {athlete.freeTrialEndDate &&
                            <>
                                {(() => {
                                    // Add 1 day to the trial days remaining to account for the current day
                                    const trialDaysRemaining = moment(athlete.freeTrialEndDate).local().diff(billingLocalTimestamp, 'days') + 1;

                                    return (
                                        <div className="pr-2">
                                            <div className="px-2 bg-green-50 text-green-700 rounded text-xs font-medium whitespace-nowrap border border-green-200">
                                                {trialDaysRemaining} day{trialDaysRemaining > 1 ? 's' : ''} remaining
                                            </div>
                                        </div>
                                    )
                                })()}

                                <div className="text-sm text-gray-500 text-right pr-2">
                                    Trial ends on {moment(athlete.freeTrialEndDate).local().format('MMMM D, YYYY')}
                                </div>
                            </>
                        }

                        {!athlete.freeTrialEndDate &&
                            <div className="text-sm text-gray-500 text-right pr-2">
                                Free trial ongoing
                            </div>
                        }

                        <div className="text-sm">${athlete.price.toFixed(2)}</div>

                    </div>

                    <div
                        className="p-4 bg-gray-50 text-gray-400 cursor-pointer hover:text-gray-600"
                        onClick={() => ShowOffboardAthleteModal(athlete)}
                    >
                        <XMarkIcon className="h-5 w-5" />
                    </div>
                </div>
            ))}
        </OrganizationBillingReceiptSectionDropdown>
    )
}